"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _constants = require("@/utils/constants");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'TableList',
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columns: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: null
    },
    tableType: {
      type: String,
      default: ''
    },
    defaultSort: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    multipleType: {
      type: String,
      default: 'currency_check'
    },
    rowKey: {
      type: String,
      default: ''
    },
    lazy: {
      type: Boolean,
      default: false
    },
    load: {
      type: Function,
      default: function _default() {}
    },
    showSummary: {
      type: Boolean,
      default: false
    },
    summaryFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    summaryMethod: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    maxHeight: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      isLoading: false,
      PAGE_SIZE_CONFIG: _constants.PAGE_SIZE_CONFIG,
      list: [],
      inputStatus: {},
      multipleSelection: []
    };
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        this.list = val;
      }
    },
    loading: {
      immediate: true,
      handler: function handler(val) {
        this.isLoading = val;
      }
    },
    defaultSort: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        this.defaultSort = val;
      }
    }
  },
  created: function created() {},
  methods: {
    // 显示编辑输入框
    showEditIput: function showEditIput(row, key) {
      this.$set(this.inputStatus, row['id'] + key, true);
      // 保存旧数据（用于取消）
      this.$set(this.inputStatus, row['id'] + key + '_old', row[key]);
    },
    // 隐藏编辑输入框
    hideEditIput: function hideEditIput(row, key) {
      row[key] = this.inputStatus[row['id'] + key + '_old'];
      this.inputStatus[row['id'] + key] = false;
    },
    // 点击按钮
    click: function click(row) {
      this.$emit('click', row);
    },
    // 改变排序
    changeSort: function changeSort(val) {
      this.$emit('changeSort', val);
    },
    // 排序方式
    sortMethod: function sortMethod(a, b) {
      this.$emit('sortMethod', a, b);
    },
    // 编辑表格输入框
    handleEdit: function handleEdit(row, key) {
      this.inputStatus[row['id'] + key] = false;
      // 未发生改变则不触发提交事件
      if (row[key] === this.inputStatus[row['id'] + key + '_old']) return;
      this.$emit('edit', row, key);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1;
      this.$emit('pageSizeChange', val);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.page = val;
      this.$emit('pageChange', val);
    },
    btnClick: function btnClick(btn, val) {
      this.$emit('btnClick', btn, val);
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
        data = param.data;
      return this.$parent.$parent.summaryMethod ? this.$parent.$parent.summaryMethod(columns, data) : this.$parent.$parent.$parent.summaryMethod(columns, data);
    },
    toggleSelection: function toggleSelection(rows) {
      var _this = this;
      if (rows) {
        rows.forEach(function (row) {
          _this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onMultiple: function onMultiple() {
      this.$emit('onMultiple', this.multipleSelection);
    },
    offMultiple: function offMultiple() {
      this.$emit('offMultiple', this.multipleSelection);
    },
    passMultiple: function passMultiple() {
      this.$emit('passMultiple', this.multipleSelection);
    },
    noPassMultiple: function noPassMultiple() {
      this.$emit('noPassMultiple', this.multipleSelection);
    },
    repayMultiple: function repayMultiple() {
      this.$emit('repayMultiple', this.multipleSelection);
    }
  }
};
exports.default = _default2;